<template>
  <vs-popup class="add-new-service"
            id="popup"
            :title="isCreateMode ? 'CREATE SERVICE' : 'UPDATE SERVICE'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-other-supplier--service-popup" @submit.prevent="handleSubmit(onClickCreateService)"
              autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="category_id" name="category_id" rules="required" v-slot="{ errors }">
                <small class="label">Suppliers</small>
                <v-select  @search="onSearch" name="user_group" :reduce="option => option.id" v-model="form.suppliers" label="company_name"
                          :closeOnSelect="false" :options="other_supplies" :dir="$vs.rtl ? 'rtl' : 'ltr'" multiple>
                  <template slot="no-options">
                    type to search supplier
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- <div v-if="!isCreateMode" class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <small class="label">Supplier Name</small>
              <vs-input v-model="form.supplier.company_name" name="company_name" class="w-full" label="" disabled/>
            </div>
          </div> -->

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="category_id" name="category_id" rules="required" v-slot="{ errors }">
                <small class="label">Category</small>
                <v-select name="user_group" :reduce="option => option.id" v-model="form.category_id" label="name"
                          :closeOnSelect="true" :options="categories" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Service/Product Name</small>
                <vs-input v-model="form.name" name="name" class="w-full" label="" :danger="!!errors[0]"
                          :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <small class="label">Nominal Code</small>
              <v-select :clearable="false" name="nominal_code" placeholder=""
                        label="name" v-model="form.sage_nominal_code_id" :reduce="option => option.id"
                        :options="sage_nominal_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea class="mb-0" v-model="form.description" height="150px"/>
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'

const OtherSupplierRepository = RepositoryFactory.get('other_supplier');
const SageSettingsRepository = RepositoryFactory.get('sage_settings');
const DropDownRepository = RepositoryFactory.get('drop_down')

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from 'vue-select'

function initialState() {
  return {
    open: false,
    id: '',
    supplier_id: '',
    form: {
      name: '',
      description: '',
      suppliers: []
    },
    isCreateMode: true,
    categories: [],
    other_supplies: [],
    sage_nominal_codes:[]
  }
}

export default {
  name: 'CreateOtherSupplierServicesPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(supplier_id, id) {
      try {
        Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        this.supplier_id = supplier_id
        await this.getSageNominalCodes()
        await this.fetchCategoryList()
        await this.fetchOtherSuppliers()
        if (!!id) {
          this.id = id
          this.isCreateMode = false
          await this.fetchServiceDetails()
        } else {
          if(!!supplier_id) {
            this.form.suppliers.push(Number(supplier_id))
          }
          this.isCreateMode = true
        }
      } catch (error) {

      }
    },
    async fetchServiceDetails() {
      await this.$vs.loading({
        container: '#create-other-supplier--service-popup',
        scale: 0.45
      })
      try {
        const {data} = (await OtherSupplierRepository.getServices(this.id)).data
        this.form = data
        this.form.category_id = data.category.id
        this.form.sage_nominal_code_id = data.sage_nominal_code.id
        this.form.suppliers = data.suppliers.map((x) => x.id)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-other-supplier--service-popup > .con-vs-loading')
    },
    async fetchCategoryList() {
      await this.$vs.loading({
        container: '#create-other-supplier--service-popup',
        scale: 0.45
      })
      try {
        const {data} = (await OtherSupplierRepository.getAllCategoryList()).data
        this.categories = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-other-supplier--service-popup > .con-vs-loading')
    },
    async getSageNominalCodes(){
      this.$vs.loading()
      const {data} = await SageSettingsRepository.getListOfSageNominalCodes('','','',0)
      this.sage_nominal_codes =  data.data
      this.$vs.loading.close()
    },
    async fetchOtherSuppliers() {
      await this.$vs.loading({
        container: '#create-other-supplier--service-popup',
        scale: 0.45
      })
      try {
        const {data} = (await DropDownRepository.getOtherSupplierList()).data
        this.other_supplies = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-other-supplier--service-popup > .con-vs-loading')
    },
    async onClickCreateService() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-other-supplier--service-popup',
        scale: 0.45
      })
      try {
        if (this.isCreateMode) {
          if(this.supplier_id) {
            this.form.supplier_id = this.supplier_id
          }
          await OtherSupplierRepository.createServices(this.form);
          this.showSuccessMessage('Service create successfully!');
        } else {
          await OtherSupplierRepository.updateServices(this.id, this.form);
          this.showSuccessMessage('Service update successfully!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-other-supplier--service-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-other-supplier--service-popup > .con-vs-loading')
    },
    onSearch(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce( async (loading, search, vm) => {
      const {data} = (await DropDownRepository.getOtherSupplierList(`filter[search]=${search}`)).data
      vm.other_supplies = data
      loading(false);
    }, 350),
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    'v-select': vSelect,
  },
}
</script>

<style scoped>
.add-new-service >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}

</style>
